import api from '../api'
import { useMutation } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'
import { IHelpDeskFormValues } from '../../interfaces/entities/IHelpDeskFormValues'

export const usePostHelpDesk = (
  successCallBack: (data: IHelpDeskFormValues) => void,
  errorCallBack: (data: any) => void,
) => {
  return useMutation(
    (helpDeskData: IHelpDeskFormValues) => api.post(ApiRouteEnum.HELP_DESK, helpDeskData),
    {
      mutationKey: [ApiRouteEnum.HELP_DESK],
      onSuccess: (data) => {
        successCallBack(data.data)
      },
      onError: (error) => errorCallBack(error),
    },
  )
}
